import { CLASSIFICATION_TYPES } from "../classification/constants";

export const isFirstBackgroundPart = (part: any) =>
  [CLASSIFICATION_TYPES.BACKGROUND_PART_LEFT, CLASSIFICATION_TYPES.BACKGROUND_PART_TOP].indexOf(part?.classificationType) !== -1;
